import { render, staticRenderFns } from "./DashboardPhotos.vue?vue&type=template&id=7c5058cd&scoped=true&"
import script from "./DashboardPhotos.vue?vue&type=script&lang=js&"
export * from "./DashboardPhotos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPhotos.vue?vue&type=style&index=0&id=7c5058cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5058cd",
  null
  
)

export default component.exports